'use client';

import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
interface Props {
  children: React.ReactNode;
}
const ModalRaw: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [initialized, setInitialized] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setInitialized(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== children || $[3] !== initialized) {
    t3 = initialized && children ? createPortal(children, document.getElementById("modal-root") as Element) : null;
    $[2] = children;
    $[3] = initialized;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default ModalRaw;